import Immutable from 'immutable'

type ImmutableProduct = Immutable.Map<string, unknown>
type ImmutableCategory = Immutable.Map<string, unknown>

export const isNotAGift = (product: ImmutableProduct) =>
  (product.get('tags', Immutable.List()) as Immutable.List<string>).filter((tag) => tag === 'gift')
    .size === 0

type ProductCategory = {
  id: string
  label: string
  count: number
}

export const getCategoriesFromProducts = (products: Immutable.Map<string, ImmutableProduct>) => {
  const numberOfProducts = products.size

  const defaultCategories: Record<string, ProductCategory> = {
    'all-products': {
      id: 'all-products',
      label: 'All Products',
      count: 0,
    },
  }

  if (!numberOfProducts) {
    return defaultCategories
  }

  defaultCategories['all-products'].count = numberOfProducts

  const categoriesAcc: Record<string, ProductCategory> = defaultCategories

  products.forEach((product) => {
    if (!product) {
      return
    }

    const productCategories = product.get('categories') as Immutable.List<ImmutableCategory>
    productCategories.forEach((category) => {
      if (!category || category.get('hidden')) {
        return
      }

      const categoryId = category.get('id') as string

      if (categoriesAcc[categoryId]) {
        categoriesAcc[categoryId].count += 1
      } else {
        categoriesAcc[categoryId] = {
          id: categoryId,
          label: category.get('title') as string,
          count: 1,
        }
      }
    })
  })

  return categoriesAcc
}
